import { render, staticRenderFns } from "./BookedCredits.vue?vue&type=template&id=2a3bb9ea"
import script from "./BookedCredits.vue?vue&type=script&lang=js"
export * from "./BookedCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports